import { useState } from "react";
import { Plus } from "@phosphor-icons/react";
import { Page, PageHeader } from "@/components/Bits";
import { useAuth } from "@/context/AuthContext";
import SubscriptionPanel from "@/components/SubscriptionPanel";
import BillingContact from "@/components/BillingContact";
import AddClientModal from "@/components/AddClientModal";

export default function Subscription() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [showAdd, setShowAdd] = useState(false);
  return (
    <Page>
      <PageHeader overline="Billing" title="Subscription"
        subtitle="Your WorkWithLottie plan, company allowance and billing cycle. Billing starts after your free trial.">
        {isAdmin && (
          <button onClick={() => setShowAdd(true)} data-testid="add-client-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium bg-[#F37A24] text-white hover:bg-navy transition-colors duration-200">
            <Plus size={17} weight="bold" /> Add a client
          </button>
        )}
      </PageHeader>
      <AddClientModal open={showAdd} onClose={() => setShowAdd(false)} />
      <SubscriptionPanel />
      <BillingContact />
    </Page>
  );
}
